import { createSelector } from "reselect";

const selectCurrent = state => state.current;

export const selectCurrentCollection = createSelector(
    [selectCurrent],
    current => current.collection
);